<template>
    <div class="row">

        <div class="col-12">
            <b-breadcrumb>
                <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                    Home
                </b-breadcrumb-item>
            </b-breadcrumb>
        </div>

        <template v-if="!hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator,ApplicationRole.Facilities,ApplicationRole.Business,ApplicationRole.TTIWebsiteAdministrator,ApplicationRole.Administrator,ApplicationRole.HR,ApplicationRole.Management)">
            <div class="col-10 alert alert-danger">
                <strong>You do not have permission to access the BIMS application. Please contact NIS if you believe you should have access.</strong>
            </div>
        </template>

        <template v-else>
            <AppCardRouterButton :route="{name:'Organizations'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator,ApplicationRole.Facilities,ApplicationRole.Business,ApplicationRole.TTIWebsiteAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa fa-8x fa-sitemap"></i>
                </template>
                <template v-slot:textContent>
                    Organizations
                </template>
            </AppCardRouterButton>
            
            <AppCardRouterButton :route="{name:'People'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator,ApplicationRole.Facilities,ApplicationRole.Business,ApplicationRole.TTIWebsiteAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa fa-8x fa-user"></i>
                </template>
                <template v-slot:textContent>
                    People
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'Buildings'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.Facilities)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-building fas"></i>
                </template>
                <template v-slot:textContent>
                    Offices
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'Keys'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.Facilities)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-key fas"></i>
                </template>
                <template v-slot:textContent>
                    Keys
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'VISAs'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.HR, ApplicationRole.Management)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-id-card fas"></i>
                </template>
                <template v-slot:textContent>
                    VISAs
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'PayPeriods'}"
                                v-if="hasApplicationRole(ApplicationRole.FinanceAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-money-check-alt fas"></i>
                </template>
                <template v-slot:textContent>
                    Acadmeic Indirect Cost
                </template>
            </AppCardRouterButton>
            
            <AppCardRouterButton :route="{name:'ComputerLeases'}"
                                v-if="hasApplicationRole(ApplicationRole.Business) && !hideFinancialServicesFeature">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-file-invoice fas"></i>
                </template>
                <template v-slot:textContent>
                    Computer Leases
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'NetworkIDTs'}"
                                v-if="hasApplicationRole(ApplicationRole.Business) && !hideFinancialServicesFeature">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-globe fas"></i>
                </template>
                <template v-slot:textContent>
                    Network IDTs
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'LeaseIDTs'}"
                                v-if="hasApplicationRole(ApplicationRole.Business) && !hideFinancialServicesFeature">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fas fa-desktop"></i>
                </template>
                <template v-slot:textContent>
                    Computer IDTs
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'AdministrativeLocations'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.HR)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-map fas"></i>
                </template>
                <template v-slot:textContent>
                    Adlocs
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'Titles'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator) && !hideTitlesFeature">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-user-tie fas"></i>
                </template>
                <template v-slot:textContent>
                    Titles
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'GeneralCodes'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fa-book fas"></i>
                </template>
                <template v-slot:textContent>
                    General Codes
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'AzureBillingPeriods'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator,ApplicationRole.NetworkAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fas fa-file-invoice-dollar"></i>
                </template>
                <template v-slot:textContent>
                    Azure Billing
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'OracleAccounts'}"
                                v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fas fa-database"></i>
                </template>
                <template v-slot:textContent>
                    Oracle
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'Settings'}"
                    v-if="hasNotDelegatedApplicationRole(ApplicationRole.Management)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fas fa-cog"></i>
                </template>
                <template v-slot:textContent>
                    Settings
                </template>
            </AppCardRouterButton>

            <AppCardRouterButton :route="{name:'DataDashboards'}"
                    v-if="hasApplicationRole(ApplicationRole.DatabaseAdministrator)">
                <template v-slot:imageContent>
                    <i aria-hidden="true" class="fa-8x fas fa-table"></i>
                </template>
                <template v-slot:textContent>
                    Data Dashboard
                </template>
            </AppCardRouterButton>
        </template>

    </div>
</template>

<script>
    import {Configuration} from "@/Configuration";
    import AppCardRouterButton from "@/components/shared/AppCardRouterButton";
    import {ApplicationRole, Role} from '@/services/models/Role';

    export default {
        data() {
            return {
                ApplicationRole: ApplicationRole,
            }
        },
        components: {
            AppCardRouterButton
        },
        computed: {
            hideFinancialServicesFeature() {
                return Configuration.FeatureToggle.FinancialServices === 'true' || Configuration.FeatureToggle.FinancialServices === true;
            },
            
            hideTitlesFeature() {
                return Configuration.FeatureToggle.Titles === 'true' || Configuration.FeatureToggle.Titles === true;
            }
        }
    };
</script>
